import config from '../config/index'
import {
  AliCloudSmsRecordResponse,
  IAliCloudSmsRecordFilterParams,
} from '../pages/ali-cloud-sms-record'
import { authRequest } from '../request'

const { mainApi } = config

export const getAliCloudSmsRecord = (data: IAliCloudSmsRecordFilterParams) =>
  authRequest.get<MISSING_TYPE, AliCloudSmsRecordResponse>(
    `${mainApi}/notifications/ali-cloud/record`,
    {
      params: data,
    },
  )
